import React from 'react';
import { useNavigate } from "react-router-dom";

const SessionExpired = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      padding: '24px',
      boxSizing: 'border-box',
    }}>
      <div style={{
        background: 'rgba(30, 41, 59, 0.7)',
        backdropFilter: 'blur(16px)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: '24px',
        padding: '48px 32px',
        maxWidth: '480px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 50px rgba(0, 0, 0, 0.3)',
      }}>
        {/* Animated Icon */}
        <div style={{
          fontSize: '72px',
          marginBottom: '24px',
          animation: 'pulse 2s infinite',
        }}>
          ⏳
        </div>

        <h1 style={{
          fontSize: '36px',
          fontWeight: 800,
          margin: '0 0 12px 0',
          background: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          letterSpacing: '-1px',
        }}>
          Sesja wygasła
        </h1>

        <p style={{
          color: '#94A3B8',
          fontSize: '15px',
          lineHeight: '1.6',
          margin: '0 0 32px 0',
        }}>
          Twoja sesja bezpieczeństwa wygasła z powodu braku aktywności. Zaloguj się ponownie, aby kontynuować pracę.
        </p>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}>
          <button
            onClick={() => navigate('/SignIn')}
            style={{
              padding: '14px 28px',
              borderRadius: '12px',
              border: 'none',
              background: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
              color: '#FFFFFF',
              fontWeight: 600,
              fontSize: '15px',
              cursor: 'pointer',
              boxShadow: '0 4px 14px rgba(245, 158, 11, 0.3)',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(245, 158, 11, 0.5)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'none';
              e.currentTarget.style.boxShadow = '0 4px 14px rgba(245, 158, 11, 0.3)';
            }}
          >
            Zaloguj się ponownie
          </button>
        </div>
      </div>
      
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(0.95); }
        }
      `}</style>
    </div>
  );
};

export default SessionExpired;